/**
 * @desc 更新
 */
const URL = "/rantion-bus";
import http, { updateResponse } from "@/http";
export function request(body: defs.bus.OpenApiConfigRequestDto, options?: any) {
  return updateResponse(
    http(URL + `/openApiConfig/update`, {
      method: "POST",

      data: body,
      ...options,
    }),
  );
}
